module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"signed-out":"アクセストークンの期限が切れたためサインアウトしました。もう一度ログインしてください。"},"en":{"signed-out":"Access token expired. Log in with Google again."}}')
  delete Component.options._Ctor
}
